import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";

const API_BASE = import.meta.env.VITE_API_BASE || "http://localhost:5000";
const MOCK_KM = 51.54;
const mockTransferCars = [
  {
    car_id: 1,
    car_name: "Toyota Hiace",
    car_image: "hiace.jpg",
    passengers: 10,
    luggage: 6,
    trnsfer_price: "0.65",
    base_price: "10.00",
    total_price: "43.25",
    available: true,
  },
  {
    car_id: 2,
    car_name: "Coaster Bus",
    car_image: "coaster.jpg",
    passengers: 22,
    luggage: 14,
    trnsfer_price: "1.20",
    base_price: "15.00",
    total_price: "77.00",
    available: true,
  },
  {
    car_id: 3,
    car_name: "Toyota Alphard",
    car_image: "alphard.jpg",
    passengers: 6,
    luggage: 4,
    trnsfer_price: "0.80",
    base_price: "8.00",
    total_price: "48.00",
    available: true,
  },
  {
    car_id: 4,
    car_name: "Toyota Noah",
    car_image: "noah.jpg",
    passengers: 4,
    luggage: 3,
    trnsfer_price: "0.65",
    base_price: "8.00",
    total_price: "40.25",
    available: true,
  },
  {
    car_id: 5,
    car_name: "Sedan",
    car_image: "sedan.jpg",
    passengers: 2,
    luggage: 2,
    trnsfer_price: "0.55",
    base_price: "5.00",
    total_price: "33.25",
    available: true,
  },
];
// const GOOGLE_MAPS_KEY = "AIzaSyCzQLn4ovNjZyXJgmS0_N7YOHD3eMiJvjs";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=Montserrat:wght@300;400;500;600;700&display=swap');

  :root {
    --black: #0a0a0a; --deep: #111111; --card: #161616;
    --border: #2a2a2a; --gold: #c9a84c; --gold-light: #e2c36e;
    --white: #f5f0e8; --grey: #888888; --grey-light: #cccccc;
    --green: #25D366; --red: #e05252;
  }
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: var(--black); color: var(--white); font-family: 'Montserrat', sans-serif; font-weight: 300; }

  @keyframes fadeUp { from { opacity:0; transform:translateY(30px); } to { opacity:1; transform:translateY(0); } }
  @keyframes shimmer { 0% { background-position:-200% center; } 100% { background-position:200% center; } }
  @keyframes spin { to { transform: rotate(360deg); } }

  /* ── PAGE HEADER ── */
  .results-header {
    background: linear-gradient(160deg, #0d0d0d 0%, #111 60%, #0a0a0a 100%);
    border-bottom: 1px solid var(--border);
    padding: 100px 60px 36px;
    position: relative; overflow: hidden;
  }
  .results-header::before {
    content:''; position:absolute; inset:0;
    background: radial-gradient(ellipse 50% 100% at 80% 50%, rgba(201,168,76,0.07) 0%, transparent 70%);
    pointer-events:none;
  }
  .results-breadcrumb {
    font-size:0.62rem; letter-spacing:0.2em; text-transform:uppercase;
    color:var(--grey); margin-bottom:14px;
  }
  .results-breadcrumb span { color:var(--gold); }
  .results-title {
    font-family:'Cormorant Garamond', serif;
    font-size:clamp(1.8rem, 3vw, 2.8rem); font-weight:300; color:var(--white);
    margin-bottom:20px;
  }
  .results-title em { font-style:italic; color:var(--gold); }

  /* ── ITINERARY STRIP ── */
  .itinerary-strip {
    display:flex; align-items:center; flex-wrap:wrap; gap:12px;
    background:var(--card); border:1px solid var(--border);
    padding:16px 24px; margin-top:20px; position:relative;
  }
  .itinerary-strip::before {
    content:''; position:absolute; top:0; left:0; right:0; height:2px;
    background:linear-gradient(90deg, transparent, var(--gold), transparent);
    background-size:200% 100%; animation:shimmer 3s ease infinite;
  }
  .itin-item { display:flex; flex-direction:column; gap:3px; }
  .itin-label { font-size:0.55rem; letter-spacing:0.25em; text-transform:uppercase; color:var(--gold); }
  .itin-value { font-size:0.8rem; color:var(--white); font-weight:500; }
  .itin-sep { color:var(--border); font-size:1.2rem; padding:0 4px; }
  .itin-arrow { color:var(--gold); font-size:1rem; }
  .edit-search-btn {
    margin-left:auto; padding:8px 20px; background:transparent;
    border:1px solid var(--border); color:var(--grey-light);
    font-family:'Montserrat',sans-serif; font-size:0.65rem;
    letter-spacing:0.15em; text-transform:uppercase; cursor:pointer;
    transition:all 0.25s;
  }
  .edit-search-btn:hover { border-color:var(--gold); color:var(--gold); }

  /* ── LAYOUT ── */
  .results-body { display:grid; grid-template-columns:1fr 340px; gap:24px; padding:40px 60px 80px; }

  /* ── CAR CARDS ── */
  .cars-list { display:flex; flex-direction:column; gap:16px; }

  .car-card {
    background:var(--card); border:1px solid var(--border);
    display:grid; grid-template-columns:200px 1fr 200px;
    opacity:0; transition:border-color 0.3s, box-shadow 0.3s;
    position:relative; overflow:hidden;
  }
  .car-card.visible { animation:fadeUp 0.5s ease forwards; }
  .car-card:hover {
    border-color:rgba(201,168,76,0.25);
    box-shadow:0 4px 32px rgba(0,0,0,0.4);
  }

  /* gold top accent line */
  .car-card::before {
    content:''; position:absolute; top:0; left:0; right:0; height:2px;
    background:linear-gradient(90deg, transparent, var(--gold), transparent);
    background-size:200% 100%; opacity:0; transition:opacity 0.3s;
  }
  .car-card:hover::before { opacity:1; animation:shimmer 2s ease infinite; }

  /* image column */
  .car-img-wrap {
    height:160px; overflow:hidden; position:relative;
    background:#111;
  }
  .car-img-wrap img {
    width:100%; height:100%; object-fit:contain;
    padding:12px;
    filter:brightness(0.9); transition:all 0.4s;
  }
  .car-card:hover .car-img-wrap img { filter:brightness(1); transform:scale(1.04); }
  .car-img-placeholder {
    width:100%; height:100%; display:flex; align-items:center;
    justify-content:center; font-size:3rem; color:var(--border);
  }

  /* info column */
  .car-info {
    padding:24px 24px; border-left:1px solid var(--border);
    display:flex; flex-direction:column; justify-content:center; gap:12px;
  }
  .car-name {
    font-family:'Cormorant Garamond',serif; font-size:1.5rem;
    font-weight:400; color:var(--white); line-height:1;
  }
  .car-specs { display:flex; gap:24px; flex-wrap:wrap; }
  .car-spec {
    display:flex; align-items:center; gap:7px;
    font-size:0.7rem; color:var(--grey); letter-spacing:0.05em;
  }
  .car-spec-icon { font-size:1rem; }

  /* price column */
  .car-price-col {
    padding:24px 20px; border-left:1px solid var(--border);
    display:flex; flex-direction:column;
    align-items:center; justify-content:center; gap:14px;
    background:rgba(0,0,0,0.2);
  }
  .car-trip-badge {
    font-size:0.55rem; letter-spacing:0.22em; text-transform:uppercase;
    padding:4px 12px;
    border:1px solid rgba(201,168,76,0.35);
    background:rgba(201,168,76,0.07); color:var(--gold);
  }
  .car-total { text-align:center; }
  .car-total-label {
    font-size:0.58rem; color:var(--grey); letter-spacing:0.15em;
    text-transform:uppercase; margin-bottom:4px;
  }
  .car-total-price {
    font-family:'Cormorant Garamond',serif; font-size:2.2rem;
    color:var(--gold); font-weight:300; line-height:1;
  }
  .car-total-currency { font-size:1rem; }
  .car-rate-note {
    font-size:0.58rem; color:var(--grey); margin-top:4px;
    letter-spacing:0.05em;
  }
  .car-btns { display:flex; flex-direction:column; gap:8px; width:100%; }
  .book-btn {
    width:100%; padding:11px 0; background:var(--gold); border:none;
    color:var(--black); font-family:'Montserrat',sans-serif;
    font-size:0.65rem; font-weight:700; letter-spacing:0.22em;
    text-transform:uppercase; cursor:pointer; transition:all 0.3s;
  }
  .book-btn:hover { background:var(--gold-light); letter-spacing:0.28em; }
  .book-btn:disabled {
    background:#1e1e1e; color:#444; cursor:not-allowed; letter-spacing:0.22em;
  }
  .details-btn {
    width:100%; padding:9px 0; background:transparent;
    border:1px solid var(--border); color:var(--grey);
    font-family:'Montserrat',sans-serif; font-size:0.62rem;
    letter-spacing:0.18em; text-transform:uppercase;
    cursor:pointer; transition:all 0.25s;
  }
  .details-btn:hover { border-color:var(--gold); color:var(--gold); }
  .unavailable-badge {
    font-size:0.58rem; letter-spacing:0.15em; text-transform:uppercase;
    color:var(--red); border:1px solid rgba(224,82,82,0.25);
    padding:6px 12px; background:rgba(224,82,82,0.05);
    text-align:center; width:100%;
  }

  /* ── LOADING / EMPTY ── */
  .results-loading {
    display:flex; flex-direction:column; align-items:center; justify-content:center;
    padding:80px 40px; gap:20px; color:var(--grey);
  }
  .spinner {
    width:36px; height:36px; border:2px solid var(--border);
    border-top-color:var(--gold); border-radius:50%;
    animation:spin 0.8s linear infinite;
  }
  .results-empty { text-align:center; padding:60px 40px; color:var(--grey); }
  .results-empty h3 { font-family:'Cormorant Garamond',serif; font-size:1.8rem; color:var(--white); margin-bottom:10px; }

  /* ── KM BADGE ── */
  .km-calculating {
    display:inline-flex; align-items:center; gap:8px;
    font-size:0.65rem; color:var(--grey); letter-spacing:0.1em;
  }
  .km-dot { width:6px; height:6px; background:var(--gold); border-radius:50%; animation:spin 1s linear infinite; }

  /* ── SIDEBAR ── */
  .sidebar { display:flex; flex-direction:column; gap:16px; }
  .sidebar-card {
    background:var(--card); border:1px solid var(--border); padding:28px;
    position:relative;
  }
  .sidebar-card::before {
    content:''; position:absolute; top:0; left:0; right:0; height:2px;
    background:linear-gradient(90deg,transparent,var(--gold),transparent);
    background-size:200% 100%; animation:shimmer 3s ease infinite;
  }
  .sidebar-title {
    font-size:0.6rem; letter-spacing:0.25em; text-transform:uppercase;
    color:var(--gold); margin-bottom:18px;
  }
  .sidebar-row { display:flex; justify-content:space-between; align-items:baseline; padding:8px 0; border-bottom:1px solid var(--border); }
  .sidebar-row:last-child { border-bottom:none; }
  .sidebar-row-label { font-size:0.68rem; color:var(--grey); }
  .sidebar-row-value { font-size:0.75rem; color:var(--white); font-weight:500; text-align:right; max-width:55%; }
  .sidebar-km { font-family:'Cormorant Garamond',serif; font-size:1.6rem; color:var(--gold); text-align:center; padding:10px 0 4px; }
  .sidebar-km-label { font-size:0.6rem; color:var(--grey); text-align:center; letter-spacing:0.15em; text-transform:uppercase; }
  .whatsapp-side {
    display:flex; align-items:center; gap:10px; padding:12px 16px;
    background:transparent; border:1px solid #25D366; color:#25D366;
    font-family:'Montserrat',sans-serif; font-size:0.65rem;
    letter-spacing:0.15em; text-transform:uppercase; cursor:pointer;
    transition:all 0.3s; text-decoration:none; justify-content:center; width:100%;
    margin-top:8px;
  }
  .whatsapp-side:hover { background:#25D366; color:var(--black); }

  /* ── MODAL ── */
  .modal-overlay {
    position:fixed; inset:0; background:rgba(0,0,0,0.8); z-index:200;
    display:flex; align-items:center; justify-content:center; padding:20px;
    animation:fadeUp 0.2s ease;
  }
  .modal-box {
    background:var(--card); border:1px solid var(--border);
    width:100%; max-width:520px; position:relative;
  }
  .modal-top { padding:24px 28px 20px; border-bottom:1px solid var(--border); }
  .modal-car-name { font-family:'Cormorant Garamond',serif; font-size:1.6rem; color:var(--white); }
  .modal-close {
    position:absolute; top:16px; right:20px; background:none; border:none;
    color:var(--grey); font-size:1.4rem; cursor:pointer; transition:color 0.2s;
  }
  .modal-close:hover { color:var(--gold); }
  .modal-body { padding:24px 28px; display:grid; grid-template-columns:1fr 1fr; gap:20px; }
  .modal-img { width:100%; border:1px solid var(--border); }
  .modal-rates { display:flex; flex-direction:column; gap:12px; }
  .modal-rate-item { padding:12px; background:var(--deep); border:1px solid var(--border); }
  .modal-rate-label { font-size:0.58rem; letter-spacing:0.2em; text-transform:uppercase; color:var(--gold); margin-bottom:4px; }
  .modal-rate-value { font-family:'Cormorant Garamond',serif; font-size:1.4rem; color:var(--white); }

  /* ── RESPONSIVE ── */
  @media (max-width: 1000px) {
    .results-body { grid-template-columns:1fr; padding:30px; }
    .results-header { padding:100px 30px 30px; }
    .car-card { grid-template-columns:160px 1fr; }
    .car-price-col { grid-column:1/-1; border-left:none; border-top:1px solid var(--border); flex-direction:row; justify-content:space-between; align-items:center; }
  }
  @media (max-width: 600px) {
    .results-header { padding:90px 20px 24px; }
    .results-body { padding:20px; }
    .car-card { grid-template-columns:1fr; }
    .car-img-wrap { height:180px; }
    .car-price-col { flex-wrap:wrap; }
    .itinerary-strip { flex-direction:column; align-items:flex-start; }
    .edit-search-btn { margin-left:0; }
  }
`;

/* ── Distance Matrix via Google Maps ── */
// function calcDistance(pickupLat, pickupLng, dropLat, dropLng) {
//   return new Promise((resolve) => {
//     if (!window.google) { resolve(0); return; }
//     const service = new window.google.maps.DistanceMatrixService();
//     service.getDistanceMatrix({
//       origins: [{ lat: pickupLat, lng: pickupLng }],
//       destinations: [{ lat: dropLat, lng: dropLng }],
//       travelMode: window.google.maps.TravelMode.DRIVING,
//       unitSystem: window.google.maps.UnitSystem.METRIC,
//     }, (response, status) => {
//       if (status === "OK" && response.rows[0].elements[0].status === "OK") {
//         resolve(parseFloat((response.rows[0].elements[0].distance.value / 1000).toFixed(2)));
//       } else {
//         resolve(0);
//       }
//     });
//   });
// }

/* ── Load Google Maps script ── */
// function loadGoogleMaps(apiKey) {
//   return new Promise((resolve) => {
//     if (window.google) { resolve(); return; }
//     const s = document.createElement("script");
//     s.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
//     s.onload = resolve;
//     document.head.appendChild(s);
//   });
// }

/* ── Car Details Modal ── */
function CarModal({ car, onClose, currency = "$" }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-top">
          <div className="modal-car-name">{car.car_name}</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          <div>
          <img
              src={`${API_BASE}/${car.car_image}`}
              alt={car.car_name}
              className="modal-img"
              onError={e => { e.target.style.display = "none"; }}
            />
            <div style={{ marginTop: 16, display: "flex", gap: 16 }}>
              <div className="car-spec"><span className="car-spec-icon">👤</span>{car.passengers} Pax</div>
              <div className="car-spec"><span className="car-spec-icon">🧳</span>{car.luggage} Bags</div>
            </div>
          </div>
          <div className="modal-rates">
            <div className="modal-rate-item">
              <div className="modal-rate-label">Base Rate</div>
              <div className="modal-rate-value">{currency}{parseFloat(car.base_price).toFixed(2)}</div>
            </div>
            <div className="modal-rate-item">
              <div className="modal-rate-label">Rate / KM</div>
              <div className="modal-rate-value">{currency}{parseFloat(car.trnsfer_price).toFixed(2)}</div>
            </div>
            <div className="modal-rate-item">
              <div className="modal-rate-label">Total Price</div>
              <div className="modal-rate-value" style={{ color: "var(--gold)" }}>
                {currency}{parseFloat(car.total_price).toFixed(2)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ── Main Page ── */
export default function TransferResults() {
  const { state }    = useLocation();
  const navigate     = useNavigate();
  const [cars, setCars]           = useState([]);
  const [loading, setLoading] = useState(true);
  const [finalKm, setFinalKm] = useState(0);
  const [modalCar, setModalCar]   = useState(null);
  const currency = "$";

  // Redirect if no state
  useEffect(() => {
    if (!state) {
      navigate("/");
      return;
    }
  
    const init = async () => {
        try {
          // Use MOCK_KM as fallback until Google Maps provides real distance
          const baseKm  = parseFloat(state.totalkm) > 0 ? parseFloat(state.totalkm) : MOCK_KM;
          const finalKm = state.oneway === "2" ? baseKm * 2 : baseKm;
          setFinalKm(finalKm);
  
          try {
            const res  = await fetch(
              `${API_BASE}/api/transfer/cars?totalkm=${finalKm}&oneway=${state.oneway}`
            );
            const data = await res.json();
  
            if (data.success) {
              setCars(data.cars);
              // Use finalKm from API response if available
              if (data.finalKm > 0) setFinalKm(data.finalKm);
            }
          } catch {
            // API not ready — use mock data with recalculated prices
            const mocks = mockTransferCars.map(car => ({
              ...car,
              total_price: parseFloat(
                (finalKm * parseFloat(car.trnsfer_price) + parseFloat(car.base_price)).toFixed(2)
              ),
              available: true,
            }));
            setCars(mocks);
          }
  
        } catch (err) {
          console.error("Transfer fetch error:", err);
        } finally {
          setLoading(false);
        }
      };
  
    init();
  
  }, []);

  // Scroll reveal
  useEffect(() => {
    if (loading) return;
    const els = document.querySelectorAll(".car-card");
    const observer = new IntersectionObserver(
      entries => entries.forEach((e, i) => {
        if (e.isIntersecting) {
          setTimeout(() => e.target.classList.add("visible"), i * 100);
          observer.unobserve(e.target);
        }
      }), { threshold: 0.1 }
    );
    els.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [loading]);

  // Inject CSS
  useEffect(() => {
    const id = "results-styles";
    if (!document.getElementById(id)) {
      const s = document.createElement("style");
      s.id = id; s.textContent = CSS;
      document.head.appendChild(s);
    }
    return () => document.getElementById(id)?.remove();
  }, []);

  const handleBook = (car) => {
    navigate("/transfer-step3", {
      state: { ...state, car, finalKm }
    });
  };

  if (!state) return null;

  return (
    <div>
      <Navbar activePage="Book a Taxi" />

      {/* ── Page Header ── */}
      <div className="results-header">
        <div className="results-breadcrumb">
          Home <span>›</span> Book a Taxi <span>›</span> Available Vehicles
        </div>
        <h1 className="results-title">
          Available Cars for <em>Transfer</em>
        </h1>

        {/* Itinerary strip */}
        <div className="itinerary-strip">
          <div className="itin-item">
            <span className="itin-label">Pickup</span>
            <span className="itin-value">{state.pickupLocation}</span>
          </div>
          <span className="itin-arrow">→</span>
          <div className="itin-item">
            <span className="itin-label">Drop-off</span>
            <span className="itin-value">{state.dropLocation}</span>
          </div>
          <span className="itin-sep">|</span>
          <div className="itin-item">
            <span className="itin-label">Date</span>
            <span className="itin-value">{state.pickupDate}</span>
          </div>
          {state.returnDate && <>
            <span className="itin-sep">|</span>
            <div className="itin-item">
              <span className="itin-label">Return</span>
              <span className="itin-value">{state.returnDate}</span>
            </div>
          </>}
          <span className="itin-sep">|</span>
          <div className="itin-item">
            <span className="itin-label">Passengers</span>
            <span className="itin-value">{state.passengers}</span>
          </div>
          <span className="itin-sep">|</span>
          <div className="itin-item">
            <span className="itin-label">Trip</span>
            <span className="itin-value">{state.oneway === "1" ? "One Way" : "Two Way"}</span>
          </div>
          {/* <button className="edit-search-btn" onClick={() => navigate(-1)}>
            ← Edit Search
          </button> */}
          <button className="edit-search-btn" onClick={() => navigate("/transfer", {
          state: state })} > ← Edit Search </button>
        </div>
      </div>

      {/* ── Body ── */}
      <div className="results-body">

        {/* ── Car List ── */}
        <div>
          {loading ? (
            <div className="results-loading">
              <div className="spinner" />
              <span style={{ fontSize: "0.75rem", letterSpacing: "0.15em" }}>
                Loading available vehicles...
              </span>
            </div>
          ) : cars.length === 0 ? (
            <div className="results-empty">
              <h3>No Vehicles Available</h3>
              <p>Try adjusting your pickup or drop-off location.</p>
            </div>
          ) : (
            <div className="cars-list">
              {cars.map(car => (
                <div className="car-card" key={car.car_id}>

                  {/* ── Image ── */}
                  <div className="car-img-wrap">
                    <img
                      src={`${API_BASE}/${car.car_image}`}
                      alt={car.car_name}
                      onError={e => {
                        e.target.style.display = "none";
                        e.target.parentElement.innerHTML = `<div class="car-img-placeholder">🚗</div>`;
                      }}
                    />
                  </div>

                  {/* ── Info ── */}
                  <div className="car-info">
                    <div className="car-name">{car.car_name}</div>
                    <div className="car-specs">
                      <div className="car-spec">
                        <span className="car-spec-icon">👥</span>
                        {car.passengers} Passengers
                      </div>
                      <div className="car-spec">
                        <span className="car-spec-icon">🧳</span>
                        {car.luggage} Luggage
                      </div>
                    </div>
                  </div>

                  {/* ── Price + Buttons ── */}
                  <div className="car-price-col">
                    <span className="car-trip-badge">
                      {state.oneway === "1" ? "One Way" : "Two Way"}
                    </span>
                    <div className="car-total">
                      <div className="car-total-label">Total Price</div>
                      <div className="car-total-price">
                        <span className="car-total-currency">{currency}</span>
                        {parseFloat(car.total_price).toFixed(2)}
                      </div>
                      <div className="car-rate-note">
                        {currency}{parseFloat(car.trnsfer_price).toFixed(2)}/km · {finalKm} km
                      </div>
                    </div>
                    <div className="car-btns">
                      {car.available ? (
                        <button className="book-btn" onClick={() => handleBook(car)}>
                          Book Now
                        </button>
                      ) : (
                        <span className="unavailable-badge">Not Available</span>
                      )}
                      <button className="details-btn" onClick={() => setModalCar(car)}>
                        Car Details
                      </button>
                    </div>
                  </div>

                </div>
              ))}
            </div>
          )}
        </div>

        {/* ── Sidebar ── */}
        <div className="sidebar">
          <div className="sidebar-card">
            <div className="sidebar-title">Booking Summary</div>
            <div className="sidebar-km">{finalKm > 0 ? `${finalKm} km` : `${MOCK_KM} km`}</div>
            <div className="sidebar-km-label">{state.oneway === "1" ? "One Way Distance" : "Total Distance (Return)"}</div>
            <div style={{ marginTop: 20 }}>
              {[
                { label: "Pickup",      value: state.pickupLocation },
                { label: "Drop-off",    value: state.dropLocation },
                { label: "Date",        value: state.pickupDate },
                { label: "Time",        value: state.pickupTime },
                ...(state.returnDate ? [
                  { label: "Return Date", value: state.returnDate },
                  { label: "Return Time", value: state.returnTime },
                ] : []),
                { label: "Passengers",  value: state.passengers },
                { label: "Trip Type",   value: state.oneway === "1" ? "One Way" : "Two Way" },
              ].map(r => (
                <div className="sidebar-row" key={r.label}>
                  <span className="sidebar-row-label">{r.label}</span>
                  <span className="sidebar-row-value">{r.value}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="sidebar-card">
            <div className="sidebar-title">Need Help?</div>
            <p style={{ fontSize: "0.72rem", color: "var(--grey)", lineHeight: 1.75, marginBottom: 8 }}>
              Book directly via WhatsApp for instant confirmation.
            </p>
            <a href="https://wa.me/255745593330" className="whatsapp-side">
              <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              WhatsApp Us
            </a>
          </div>
        </div>
      </div>

      {/* ── Modal ── */}
      {modalCar && <CarModal car={modalCar} currency={currency} onClose={() => setModalCar(null)} />}
    </div>
  );
}